const ANIMATION_TIME = 300;
const DISMISS_TIME = ANIMATION_TIME + 5000;

export default {
    ANIMATION_TIME,
    DISMISS_TIME
};
